import React from "react";
import { Box, Button, Text } from "@dxp-feed/ui";
import parse from "html-react-parser";
interface UpdateStoreModalHeaderProps {
  confirmStoreSelection: () => void;
  cancelStoreSelection: () => void;
  confrimLoading: boolean;
  storeAEMData: any;
}

const UpdateStoreModalHeader: React.FC<UpdateStoreModalHeaderProps> = ({
  confirmStoreSelection,
  cancelStoreSelection,
  confrimLoading,
  storeAEMData,
}) => {
  return (
    <Box className="text-brandBlack p-6 pb-3 flex flex-col gap-3 text-body">
      <Text as="p" className="sm:block hidden font-bold text-base mb-3">
        {storeAEMData?.sheetHeading || "Update Selected Store"}
      </Text>
      <Text as="p">{storeAEMData?.subheading || "Prices shown reflect in-store prices"}</Text>
      <Text as="p" className="font-bold">
       {parse(storeAEMData?.mainHeading?.html || "Updating your selected store may result in changes to products and prices displayed on Sobeys.com")}
      </Text>
      <Text as="p" className="mb-3">
        {storeAEMData?.confirmationText || "Do you wish to continue?"}
      </Text>
      <Box className="flex gap-3 flex-col">
        {confrimLoading ? (
          <>
            <Button
              aria-label="Updating store..."
              className="w-full font-normal cursor-not-allowed"
            >
              Updating store...
            </Button>
            <Button
              className="w-full font-normal cursor-not-allowed"
              variant="outline"
              aria-label={storeAEMData?.noButtonText || "No, maintain previously selected store"}
            >
              {storeAEMData?.noButtonText || "No, maintain previously selected store"}
            </Button>
          </>
        ) : (
          <>
            <Button
              className="w-full font-normal !text-body min-h-10 px-6"
              onClick={confirmStoreSelection}
              aria-label={storeAEMData?.yesButtonText || "Yes, continue updating selected store"}
            >
              {storeAEMData?.yesButtonText || "Yes, continue updating selected store"}
            </Button>
            <Button
              className="w-full font-normal !text-body min-h-10 px-6"
              variant="outline"
              onClick={cancelStoreSelection}
              aria-label={storeAEMData?.noButtonText || "No, maintain previously selected store"}
            >
              {storeAEMData?.noButtonText || "No, maintain previously selected store"}
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default UpdateStoreModalHeader;
